import { collectBlocksStyles, mergeCollectedBlockStyles } from '@benzinga/blocks-utils';
import { WordpressPost } from '@benzinga/content-manager';

export const collectStylesFromMoneyPost = (postData: WordpressPost): string => {
  try {
    const sidebarBlocksStyles = collectBlocksStyles(postData?.sidebar?.blocks);
    const contentBlocksStyles = collectBlocksStyles(postData?.blocks);
    const footerBlocksStyles = collectBlocksStyles(postData?.content_footer?.blocks);
    const headerBlocksStyles = collectBlocksStyles(postData?.header?.blocks);
    const contentHeaderBlocksStyles = collectBlocksStyles(postData?.content_header?.blocks);
    const globalFooterBlocksStyles = collectBlocksStyles(postData?.global_footer?.blocks);

    return mergeCollectedBlockStyles({
      ...sidebarBlocksStyles,
      ...contentBlocksStyles,
      ...footerBlocksStyles,
      ...headerBlocksStyles,
      ...contentHeaderBlocksStyles,
      ...globalFooterBlocksStyles,
    });
  } catch {
    return '';
  }
};
